import { fitTextOnNLines } from "@remotion/layout-utils";
import { useEffect, useRef, useState } from "react";

export default function NewsSlidePreview({ news, styleSettings }) {
  const containerRef = useRef(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    function updateScale() {
      if (!containerRef.current) return;
      const width = containerRef.current.getBoundingClientRect().width;
      setScale(width / 1920);
    }
    updateScale();
    window.addEventListener("resize", updateScale);
    return () => window.removeEventListener("resize", updateScale);
  }, []);

  return (
    <div
      ref={containerRef}
      className="w-full relative select-none"
      style={{
        aspectRatio: "16 / 9",
        overflow: "hidden",
        backgroundColor: "#000",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: 1920,
          height: 1080,
          transform: `scale(${scale})`,
          transformOrigin: "top left",
        }}
      >
        {/* Background Image */}
        <img
          src={news.image}
          alt=""
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            position: "absolute",
            top: 0,
            left: 0,
          }}
        />

        {/* Category top-left */}
        <div
          style={{
            position: "absolute",
            top: 40,
            left: 60,
            fontSize: 48,
            fontWeight: "bold",
            width: "max-content",
            height: "max-content",
            padding: 10,
            backgroundColor:
              styleSettings?.slideItem?.category?.backgroundColor || "#fff",
            color: styleSettings?.slideItem?.category?.color || "#000",
            fontFamily: "Merriweather",
            zIndex: 2,
          }}
        >
          {news.category}
        </div>

        {/* Title - positioned above subtitle */}
        <div
          style={{
            position: "absolute",
            paddingLeft: 60,
            paddingRight: 60,
            paddingTop: 40,
            paddingBottom: 40,
            color: styleSettings?.slideItem?.title?.color,
            fontFamily: "Merriweather",
            fontWeight: "bold",
            backgroundColor: styleSettings?.slideItem?.title?.backgroundColor,
            top: "calc(100% - 240px)",
            bottom: 0,
            width: "100%",
            fontSize: fitTextOnNLines({
              text: styleSettings?.slideItem?.title?.text ?? news.title,
              maxBoxWidth: 1920 - 120,
              maxLines: 3,
              fontFamily: "Merriweather",
              fontWeight: "bold",
              maxFontSize: 48,
            }).fontSize,
          }}
        >
          {news.title}
        </div>
      </div>
    </div>
  );
}
